<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <ul class="heading-ul mb-3">
          <li class="flex items-center gap-3">
            <router-link to="/setup/plan-validation-rules" class="mr-2 mt-1">
              <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            </router-link>
            <h3>{{ $t("setup.label.ViewValidationRule") }}</h3>
          </li>
        </ul>
      </div>
      <div class="vx-col md:w-full lg:w-full sm:w-full w-full mb-base">
        <vx-card>
          <div class="vx-row">
            <div class="vx-col w-full md:w-full lg:w-full">
              <ul class="horizontal-sm-btn flex mb-2 float-right">
                <li>
                  <div
                    class="p-1 cursor-pointer flex items-center text-lg font-medium w-full"
                  >
                    <vs-button
                      color="primary"
                      icon-pack="feather"
                      icon="icon-edit-2"
                      class="truncate"
                      @click="editData(id)"
                      size="small"
                      >{{ $t("setup.label.Edit") }}</vs-button
                    >
                    <vs-button
                      color="danger"
                      icon-pack="feather"
                      icon="icon-x"
                      class="truncate"
                      size="small"
                      @click="deleteValidationRulePopup = true"
                      >{{ $t("setup.label.Delete") }}</vs-button
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div class="vx-row">
            <div class="w-full">
              <div class="block overflow-x-auto">
                <table class="table w-full table-bordered table-striped">
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.InputPlanId") }}</b>
                    </td>
                    <td>{{ getPlanDescription(DataById.inputPlanId) }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.CheckinPlanId") }}</b>
                    </td>
                    <td>{{ getPlanDescription(DataById.checkinPlanId) }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.RuleAppliesTo") }}</b>
                    </td>
                    <td>{{ getRulesAppliesTo(DataById.ruleAppliesTo) }}</td>
                  </tr>
                  <tr>
                    <td>
                      <b>{{ $t("setup.label.Rule") }}</b>
                    </td>
                    <td>{{ getRule(DataById.rule) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <delete-popup
      :deletePopup="deleteValidationRulePopup"
      :title="$t('setup.label.ValidationRule')"
      @deletePressed="deleteValidationRuleMethod()"
      @cancelPressed="deleteValidationRulePopup = false"
    >
    </delete-popup>
  </div>
</template>
<script>
import moment from "moment";
import vSelect from "vue-select";
import { mapState } from "vuex";
export default {
  data() {
    return {
      id: "",
      delId: "",
      deleteValidationRulePopup: false,
    };
  },
  components: {
    "v-select": vSelect,
  },
  computed: {
    ...mapState({
      DataById: (state) => state.planValidationRules.validationRuleById,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      return moment(date).format(this.formattedDate);
    },
    editData() {
      this.$router.push(`/setup/plan-validation-rules/edit-validation-rule/${this.id}`);
    },
    async deleteValidationRuleMethod() {
      this.deleteValidationRulePopup = false;
      await this.$store.dispatch(
        "planValidationRules/deletePlanValidationRuleAction",
        this.id
      );
      this.$router.push(`/setup/plan-validation-rules`);
    },
    getPlanDescription(id) {
      const plan = this.DataById.planList.find(
        (plan) => plan.id === id
      );
      return plan ? plan.planDescription : "N/A";
    },
    getRulesAppliesTo(id) {
      const plan = this.DataById.ruleAppliestoList.find(
        (plan) => plan.id === id
      );
      return plan ? plan.mCodeValue : "N/A";
    },
    getRule(id) {
      const plan = this.DataById.ruleExpressionList.find(
        (plan) => plan.id === id
      );
      return plan ? plan.mCodeValue : "N/A";
    },
    async getDataById() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getPlanValidationRuleByIdAction",
          this.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id;
    this.getDataById();
  },
};
</script>
<style scoped>
.table {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: #fff;
  border: solid 1px #f0f0f0;
}

.table td {
  vertical-align: middle;
  border-top: none;
  padding: 10px 7px;
  font-size: 14px;
  color: #646a71;
  border-bottom: 1px solid #dfe3e7;
  transition: all 0.2s ease;
  overflow: hidden;
  word-break: break-all;
}
</style>
